import service from '@/store/services/seguroiparcelamentos-service';

const state = {
  list: {},
  seguroiparcelamento: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, seguroiparcelamento) => {
    state.seguroiparcelamento = seguroiparcelamento;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((seguroiparcelamento) => { commit('SET_RESOURCE', seguroiparcelamento); });
  },

  baixarArquivo({ commit, dispatch }, params) {
    // Chama a função do serviço para baixar o PDF
      return service.downloadPDF(params[0],params[1])
        .then((resposta) => {
          // Manipular a resposta, se necessário
          //console.log("PDF baixado com sucesso!", resposta);
          return resposta;
        })
        .catch((erro) => {
          // Lidar com erros, como usuário não autenticado
          console.error("Erro ao baixar a apólice:", erro);
          throw erro;
        });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((seguroiparcelamento) => { commit('SET_RESOURCE', seguroiparcelamento); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((seguroiparcelamento) => { commit('SET_RESOURCE', seguroiparcelamento); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  seguroiparcelamento: state => state.seguroiparcelamento,
  dropdown: (state) => {
    return state.list.map(seguroiparcelamento => ({
      id: seguroiparcelamento.id,
      name: seguroiparcelamento.qtdparcelas + "x de aprox r$ " + seguroiparcelamento.valor1aparcela
    }));
  }
};

const seguroiparcelamentos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default seguroiparcelamentos;
